import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-surevey-conduct',
  templateUrl: './surevey-conduct.component.html',
  styleUrls: ['./surevey-conduct.component.scss'],
  providers: [DatePipe],
})
export class SureveyConductComponent implements OnInit {
  form: FormGroup;
  submitted = false;

  roledata: any;
  disable = false;
  response;
  rolebased = [{ role: 'Trader' }, { role: 'Farmer' }];
  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  today = new Date();
  currentD = this.datepipe.transform(this.today, 'dd/MM/yyyy');
  targetstate = [];
  targetstateList: string[] = [
    'Telangana',
    'Tamil Nadu',
    'Kerala',
    'Karnataka',
    'Andhra Pradesh',
  ];
  finaldata: any;
  remark: any;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [
        '',
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ], //mandatory include document Attchment
      surveyLink: [
        '',
        [
          Validators.pattern(
            "((https?://)?([\\da-z.-]+)\\.[a-zA-Z0-9',._.!#$%&+/=?^@_`{|}~-]+( [a-zA-Z0-9',._-]+)*){2,150}"
          ),
        ],
      ],
      resultLink: [
        '',
        [
          Validators.pattern(
            "((https?://)?([\\da-z.-]+)\\.[a-zA-Z0-9',._.!#$%&+/=?^@_`{|}~-]+( [a-zA-Z0-9',._-]+)*){2,150}"
          ),
        ],
      ],
      roles: [], //mandatory
      targetstate: ['', [Validators.required]], //mandatory
      remark: [''], //mandatory
    });
  }
  get attach_url() {
    return this.form.get('surveyLink');
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid) {
      if (this.form.value.surveyLink != '') {
        var pattern = new RegExp(this.reg);
        var result = pattern.test(this.form.value.surveyLink);
        if (result == false) {
          alert('Please enter valid surveyLink');
          return false;
        }
      }

      this.spinner.show();
      // {
      //   "surveyName": "string",
      //   "surveyLink": "string",
      //   "resultLink": "string",
      //   "role": "string",
      //   "surveyDate": "string",
      //   "remark": "string",
      //   "states": [
      //   "string"
      //   ]
      //   }
      var formdata = {
        surveyName: this.form.value.name,
        // PublishDate: this.datepipe.transform(this.form.controls.date.value, 'yyyy-MM-ddThh:mm:ss'),
        surveyLink: this.form.value.surveyLink,
        resultLink: this.form.value.resultLink,
        role: this.form.value.roles.join(','),
        remark: this.form.value.remark,
        states: this.form.value.targetstate,
        // Languages: this.form.value.languages
        // Languages: `{"${this.form.value.languages.join(',')}"}`,
      };
      if (confirm('Do you want to share this survey?')) {
        this._userService.postsurveydata(formdata).subscribe((data) => {
          this.response = data;
          // if (confirm("Do you want to send this notification to selected state/s users?")) {

          // this._userService.sentapplicationremaindernotification(formdata).subscribe(data => {
          //   this.response = data;
          // });
          this.spinner.hide();
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
        });
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/survey-conduct']);
          this.spinner.hide();
        });
      } else {
        this.spinner.hide();
      }
      // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/Fertilizer']);
      //   this.spinner.hide()
      // });
    } else {
      alert('Please fill all mandatory fields and enter valid values');
    }
  }
  dataPage() {
    this.router.navigate(['/survey-data']);
  }

  //   getToday(): string {
  //     return new Date().toISOString().split('T')[0]
  //  }
}
// onSubmit() {
//   if (this.form.value.surveyLink != '') {
//     var pattern = new RegExp(this.reg);
//     var result = pattern.test(this.form.value.surveyLink);
//     if (result == false) {
//       alert('Please enter valid surveyLink.')
//       return false
//     }
//   }
//   this.spinner.show()
//   var datepublished = this.datepipe.transform(this.today, 'dd-MM-yyyy');

//   let myfile = this.finaldata
//   const postdata = new FormData();
//   postdata.append('SchemtTitle', this.form.value.SchemtTitle);

//   // if(this.savescheme == false){
//   //   this.toastr.error("Please Give Description or Please upload File For Govt Scheme Update", 'Error', {
//   //     timeOut: 3000,
//   //   });
//   // }
//   if (this. rolebased== undefined || this.form.value.SchemtName == "" || this.form.value.Description == "") {
//     alert("Please Enter Mandatory fields")
//   }
//   else {

//     let text = confirm("Are you sure you want to publish this survey ?");
//     if(text==true){

//     // postdata.append('DatePosted', datepublished);
//     postdata.append('surveyName', this.form.value.Description);

//     postdata.append('surveyLink', this.form.value.SurveyLink);
//     postdata.append('ResultLink', this.form.value.ResultLink);
//     postdata.append('role', "");
//     postdata.append('surveyDate', "");
//     postdata.append('remark', "");
//     postdata.append('states', "");

//     this._userService.postsurveydata(postdata).subscribe(data => {
//       this.response = data;
//       this.spinner.hide()
//       // var message:any = response.result.data
//       // alert(message.message);
//       this.toastr.success(this.response.result.message, 'Success', {
//         timeOut: 3000,

//       });
//     });
//     this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
//       this.router.navigate(['/survey-conduct']);
//     });
//   }else{
//   //  return false;
//   }
// }
//   this.spinner.hide()
// }

// listPage() {
//   this.router.navigate(['/Govt-schemes-list']);
// }

// removeFile() {
//   this.isButtonVisible = false;
//   this.myInputVariable.nativeElement.value = '';
// }
